export const environment = {
	production: false,
	api: 'https://test-api.lmsleads.com/',
	domain: 'https://test-admin.lmsleads.com',
	// TODO: replace with the real N8N webhook URL for the Vera chatbot workflow.
	veraWebhookUrl: 'https://n8n.srv796644.hstgr.cloud/webhook/chatbot',
	defaultauth: 'firebase',
	firebaseConfig: {
		apiKey: 'AIzaSyC97mpFWAzru_N5T-t9RPeLxs9mnDcEyEA',
		authDomain: 'lms-leads.firebaseapp.com',
		projectId: 'lms-leads',
		storageBucket: 'lms-leads.appspot.com',
		messagingSenderId: '583949757063',
		appId: '1:583949757063:web:4ddf556141003f9d13e622',
	},
};

export const oldEnvironment = {
	production: false,
	currentDomain: 'https://old.api.lmsleads.com/',
	api: 'https://old.api.lmsleads.com/old-api/',
	uploadFilesUrl: 'https://old.api.lmsleads.com/old-api/lead/upload_file.php',
	environment: '',
};
